import {connect, setRecomputeState as setState} from '@gisatcz/ptr-state';
import {PresentationMap} from '@gisatcz/ptr-maps';

import Action from '../../../../../../../state/Action';
import Select from '../../../../../../../state/Select';
import {mapCoordinatesControl} from '../../../../../../../constants/app';

const mapStateToProps = (state, ownProps) => {
	setState(state);

	return {
		backgroundLayer: Select.maps.getMapBackgroundLayer(ownProps.stateMapKey),
		layers: Select.maps.getMapLayers(ownProps.stateMapKey),
		viewport: Select.maps.getViewportByMapKey(state, ownProps.stateMapKey),
		view: Select.maps.getViewByMapKey(state, ownProps.stateMapKey),
		viewLimits: Select.maps.getViewLimitsByMapKey(state, ownProps.stateMapKey),
		mapKey: ownProps.stateMapKey,
	};
};

const mapDispatchToPropsFactory = () => {
	return (dispatch, ownProps) => {
		return {
			onMount: (mapWidth, mapHeight) => {
				dispatch(
					Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
				);
				dispatch(Action.maps.use(ownProps.stateMapKey, null, null));
			},

			onResize: (mapWidth, mapHeight) => {
				dispatch(
					Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
				);
				dispatch(Action.maps.use(ownProps.stateMapKey, null, null));
			},

			onUnmount: () => {
				dispatch(Action.maps.mapUseClear(ownProps.stateMapKey));
			},
			onViewChange: update => {
				dispatch(Action.maps.updateMapAndSetView(ownProps.stateMapKey, update));
			},
			onClick: () => {
				dispatch(Action.maps.setMapSetActiveMapKey(ownProps.stateMapKey));
			},
			onLayerClick: (mapKey, layerKey, featureKeys) => {
				dispatch(
					Action.worldWater.setActivePlaceByFeatureKey(
						featureKeys?.[0],
						ownProps.onPlaceSelect
					)
				);
				dispatch(Action.components.set(mapCoordinatesControl, 'active', false));
			},
		};
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToPropsFactory
)(PresentationMap);
